import React from 'react';
import '../../pages/foamwood/sliderfoamwood.css';
import Polyester1 from '../../images/newproductslider/polyester.png';
import Polyester2 from '../../images/newproductslider/polyester.png';
import Polyester3 from '../../images/newproductslider/polyester.png';
function SliderPolyesterTiles() {
    return (

        <>
            <div id="slider-foamwood">
                <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                    <ol className="carousel-indicators">
                        <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                    </ol>
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img className="d-block w-100" src={Polyester1} alt="Ceiling Panels" />
                            <div className="carousel-caption d-none d-md-block">
                                <h2>Polyester Ceiling Tiles</h2>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <img className="d-block w-100" src={Polyester2} alt="Ceiling Panels" />
                            <div className="carousel-caption d-none d-md-block">
                                <h2>Polyester Ceiling Tiles</h2>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <img className="d-block w-100" src={Polyester3} alt="Ceiling Panels " />
                            <div className="carousel-caption d-none d-md-block">
                                <h2>Polyester Ceiling Tiles</h2>
                            </div>
                        </div>
                    </div>
                    <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="sr-only">Previous</span>
                    </a>
                    <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="sr-only">Next</span>
                    </a>
                </div>
            </div>
        </>
    );
}
export default SliderPolyesterTiles;